<template>
    <td class="scope-circles-cell">
        <tippy :content="scope.title" v-for="scope in scopes">
            <ux-circle :value="scope"/>
       </tippy>
    </td>
</template>
<script>
import TableCellMixin from './TableCellMixin.js';
import UxCircle from '../../ui/circle.vue';

export default {
    mixins:[TableCellMixin],
    components:{
        UxCircle,
    },
    computed:{
        scopes() {

            if(this.column.key === '_id') {
                return [this.row];
            }
            
            return this.value
        }
    },
}
</script>
<style scoped lang="scss">
td {
    text-align: center;
    white-space: nowrap;
}
</style>